import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface LoadingIndicatorProps {
  hasLoadingText?: boolean;
  color: "primary" | "secondary" | "inherit" | "contrast" | undefined;
  size: string;
}

export const LoadingIndicator: React.FC<Partial<LoadingIndicatorProps>> = ({
  hasLoadingText = true,
  size,
  color,
}) => {
  const { t } = useTranslation("common");

  return (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      style={{ color: color }}
      alignItems="center"
      data-testid="loading-indicator"
    >
      <CircularProgress
        //@ts-ignore
        color={color}
        size={size}
      />
      {hasLoadingText && (
        <Box display="flex" alignItems="center">
          <Typography variant="caption" component="div" color="textSecondary">
            {t("loading")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
